//URL de  desarrollo
// const baseURLFetch = 'http://localhost:3003'

//URL de produccion prueba
// const baseURLFetch = 'https://elmediodemedios.com/api'

//URL de produccion
const baseURLFetch = 'https://elmediodemedios.com/api'

// URLs fetch GET
export const getProductsURL = () => {
    return `${baseURLFetch}/product`
}


// URLs fetch POST

export const postCreateSessionURL = () => {
    return `${baseURLFetch}/payment/create-session`
}

export const postRequestCancelURL = () => {
    return `${baseURLFetch}/subscription/request-cancel`
}

export const postCancelURL = () => {
    return `${baseURLFetch}/subscription/verify-code-cancel`
}

export const getBoletinesURL = (documentReference) => {
    return `https://backend.elmediodemedios.com/archivos?_sort=created_At:DESC&categorias.nombre_eq=${documentReference}`
}

export const sectionsByDocument = (id_documento) =>
    `/sections/${id_documento}`;

export const notesBySection = (id_documento, id_seccion, fecha) =>
    `/notes?id_documento=${id_documento}&id_seccion=${id_seccion}&fecha=${fecha}`;

export const loginURL = () => `/usersManagement/login`;

export const specialDocumentNotes = (fecha) =>
  `/notes/special-document?fecha=${fecha}`;

export const complementMDM = (id_documento, isPreview = false) =>
  `/notes/complementMDM/${id_documento}/${isPreview}`;

export const fullComplementMDM = () =>
  process.env.REACT_APP_IS_PREVIEW === 'true' ? `/json/` : `/notes/complementMDM/all`;

export const extractionCartons = (urlTestigo) =>
    `/extract?url=${urlTestigo}`;
